const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/PageErrorBoundary/PageErrorBoundary.tsx';
import { Icon } from '@mui/material';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import { ErrorPage } from '../../pages/ErrorPage/ErrorPage';
import { useIntl } from 'react-intl';

import textMap from './translations';

interface PageErrorBoundaryProps {
    errorDescription?: string;
    errorText?: string;
    hideRestartBtn?: boolean;
    children?: any;
}

export const PageErrorBoundary = (props: PageErrorBoundaryProps) => {
    const { formatMessage } = useIntl();

    const icon = <Icon fontSize={'inherit'} className={'icons8-error'} />;

    const errorText = props.errorText || formatMessage(textMap.unexpectedError);

    const errorSummary = props.errorDescription || formatMessage(textMap.restartApp);

    /**
     * Helper function to render the fallback component
     */

    const getDynamicFallback = (err: Error) => (
        <ErrorPage
            icon={icon}
            error={err}
            header={errorText}
            summary={errorSummary}
            hideRestartBtn={props.hideRestartBtn}
        />
    );

    return (
        <ErrorBoundary getDynamicFallback={getDynamicFallback} shouldShowSnackbar={false} shouldShowDialog={false}>
            {props.children}
        </ErrorBoundary>
    );
};
